import { Injectable } from '@angular/core';

@Injectable()
export class ConstantsService {
  static siteName = 'Cargoexpress';
  static email = 'vanzari@cargoexpress.ro';
  static telefon = '+40757645405';
}
